export enum MappingFilterCheckState {
  CHECKED = 'CHECKED',
  UNCHECKED = 'UNCHECKED',
  INDETERMINATE = 'INDETERMINATE',
}

export enum MappingFilterType {
  ALL_ITEMS = 'ALL_ITEMS',
  DIRECT_ITEMS = 'DIRECT_ITEMS',
  INHERITED_ITEMS = 'INHERITED_ITEMS',
}

export enum MappingFilterCategory {
  RELATIONSHIP = 'RELATIONSHIP',
  ATTRIBUTE = 'ATTRIBUTE',
}
